export default function CookieConsent() {
  return {
    show: false,
    showSettings: false,
    preferences: {
      essential: true, // Always true, cannot be disabled
      analytics: false,
    },

    init() {
      // Check if user has already made a choice
      const savedConsent = localStorage.getItem('cookieConsent');
      if (savedConsent) {
        this.preferences = JSON.parse(savedConsent);
        this.applyCookiePreferences();
      } else {
        this.show = true;
      }
    },

    acceptAll() {
      this.preferences = {
        essential: true,
        analytics: true,
      };
      this.applyCookiePreferences();
      this.savePreferences();
      this.show = false;
    },

    rejectAll() {
      this.preferences = {
        essential: true, // Essential cookies are always enabled
        analytics: false,
      };
      this.applyCookiePreferences();
      this.savePreferences();
      this.show = false;
    },

    savePreferences() {
      localStorage.setItem('cookieConsent', JSON.stringify(this.preferences));
      this.applyCookiePreferences();
      this.show = false;
    },

    applyCookiePreferences() {
      // Apply analytics cookies based on preferences
      if (this.preferences.analytics) {
        this.enableAnalyticsCookies();
      } else {
        this.disableAnalyticsCookies();
      }
    },

    enableAnalyticsCookies() {
      // Enable PostHog analytics
      if (window.posthog) {
        posthog.opt_in_capturing();
      }
      // Enable Google Analytics through GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'consent_update',
          consent_state: {
            analytics_storage: 'granted',
            ad_storage: 'denied', // We don't use ad storage
          },
        });
      }
    },

    disableAnalyticsCookies() {
      // Disable PostHog analytics
      if (window.posthog) {
        posthog.opt_out_capturing();
      }
      // Disable Google Analytics through GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'consent_update',
          consent_state: {
            analytics_storage: 'denied',
            ad_storage: 'denied',
          },
        });
      }
    },
  };
}
